<template>
  <Container>
    <PageHeader :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar :options="calendarOptions" />
              <Booking :arrival="checkin_date" :departure="checkout_date" @submit="setBookings" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import bookingMixin from "@/mixins/booking-mixin";

export default {
  page: {
    title: "Calendar",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
    PageHeader,
  },

  mixins: [bookingMixin],

  data() {
    return {
      items: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Calendar",
          active: true,
        },
      ],
    };
  },
};
</script>

<style>
.fc-event-start {
  margin-left: 4.5vw !important;
}

.fc-event-end {
  margin-right: 4.5vw !important;
}

.fc-highlight {
  background: rgba(85, 110, 230, 0.25) !important;
}

.fc-event {
  cursor: pointer !important;
}
</style>
